<template>
  <a-modal
    :title="title"
    :width="640"
    :visible="visible"
    okText="确认"
    cancelText="取消"
    @ok="
      () => {
        $emit('ok')
      }
    "
    @cancel="
      () => {
        $emit('cancel')
      }
    "
  >
    <a-spin :spinning="loading">
      <a-form :form="form" v-bind="formLayout">
        <a-form-item label="资源库名称">
          <a-input v-decorator="['name', { rules: [{ required: true, message: '请输入名称' }] }]" />
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import { requestUrl } from '@/utils/request_url'
const fields = ['name']
export default {
  name: 'ResourceEditForm',
  props: {
    loading: {
      type: Boolean,
      default: () => false,
    },
    model: {
      type: Object,
      default: () => null,
    },
    title: {
      type: String,
      default: '新增',
    },
    visible: {
      type: Boolean,
      required: true,
    }
    
  },
  data() {
    this.formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 },
      },
    }
    return {
      form: this.$form.createForm(this),
       imageUrl2:'',
      iconUpload: false,
      headers: {},
    }
  },
  created() {
    fields.forEach((v) => this.form.getFieldDecorator(v))
    this.$watch('model', () => {
      this.model && this.form.setFieldsValue(pick(this.model, fields))
    })
  },
  // watch: {
  //   imageUrl: function (val) {
  //     debugger
  //   },
  // },
  computed: {
  },
  mounted() {},
  methods: {
  },
}
</script>
